import styled from 'styled-components'
import { Chip, FormGroup } from '@material-ui/core'

export const StyledFormGroup = styled(FormGroup)`
  margin-top: 16px;
` as any

export const StyledChip = styled(Chip)`
  margin-top: 4px;
  height: 24px;
` as any
